import { Box, Divider, Tab, Tabs, styled } from '@mui/material';
import Stores from './Stores';
import OpeningHours from './OpeningHours';
import theme from '../../theme';

const StyledTabs = styled(Tabs)({
  '& .MuiTabs-indicator': {
    display: 'none',
  },
  '& .MuiTab-root': {
    textTransform: 'none',
    fontWeight: 400,
    fontSize: '16px',
    color: 'text.secondary',
    '&.Mui-selected': {
      color: theme.palette.custom.textBlue,
      fontWeight: 500,
      backgroundColor: theme.palette.custom.sidebarActiveBg,
      borderRadius: '6px',
    },
  },
});

interface TabPanelProps {
  children: React.ReactNode;
  value: number;
  index: number;
}

const TabPanel = ({ children, value, index }: TabPanelProps) => {
  return value === index ? <>{children}</> : null;
};

interface StoreManagementTabsProps {
  selectedTab: number;
  setSelectedTab: (value: number) => void;
  storesData: any;
  storesListLoading: boolean;
  onEditStore: (store: any) => void;
  onStoreSelect?: (store: any) => void;
  onAddStoreHours: (store: any) => void;
  onAddStoreMenu: (store: any) => void;
  storesListError?: any;
  isStoresListError?: boolean;
  brandsList: any;
  paginationModel: { page: number; pageSize: number };
  onPaginationModelChange: (model: { page: number; pageSize: number }) => void;
}

const StoreManagementTabs = ({
  selectedTab,
  setSelectedTab,
  storesData,
  brandsList,
  storesListLoading,
  onEditStore,
  onStoreSelect,
  onAddStoreHours,
  onAddStoreMenu,
  storesListError,
  isStoresListError,
  paginationModel,
  onPaginationModelChange,
}: StoreManagementTabsProps) => {
  const tabItems = [
    {
      label: 'Outlets',
      component: (
        <Stores
          storesData={storesData}
          storesListLoading={storesListLoading}
          onEditStore={onEditStore}
          brandsList={brandsList}
          onStoreSelect={onStoreSelect}
          onAddStoreHours={onAddStoreHours}
          onAddStoreMenu={onAddStoreMenu}
          storesListError={storesListError}
          isStoresListError={isStoresListError}
          paginationModel={paginationModel}
          onPaginationModelChange={onPaginationModelChange}
        />
      ),
    },
    { label: 'Opening Hours', component: <OpeningHours /> },
  ];

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        backgroundColor: '#FFF',
        borderRadius: '8px',
        border: '1px solid #DCE0E7',
      }}
    >
      <Box sx={{ padding: '10px 16px' }}>
        <StyledTabs value={selectedTab} onChange={handleTabChange}>
          {tabItems.map((tab, i) => (
            <Tab key={i} label={tab.label} />
          ))}
        </StyledTabs>
      </Box>
      <Divider />
      <Box
        sx={{
          flexGrow: 1,
          overflow: 'auto',
          '&::-webkit-scrollbar': { display: 'none' },
          msOverflowStyle: 'none',
          scrollbarWidth: 'none',
        }}
      >
        {tabItems.map((tab, index) => (
          <TabPanel key={index} value={selectedTab} index={index}>
            {tab.component}
          </TabPanel>
        ))}
      </Box>
    </Box>
  );
};

export default StoreManagementTabs;
